import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="71.875" height="93.438" viewBox="0 0 71.875 93.438"><path d="M21.563-89.844V3.594H93.438V-66.147l-23.7-23.7Zm7.188,7.188H64.688v21.563H86.25v57.5H28.75ZM71.875-77.6,81.2-68.281H71.875ZM57.5-53.906,43.125-39.531H53.906v17.969h7.188V-39.531H71.875ZM43.125-17.969v7.188h28.75v-7.187Z" transform="translate(-21.563 89.844)"/></svg>
)
